import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/style.css';
import './assets/css/queries.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

createApp(App).mount('#app')
